import PointView from './PointView';

export default PointView;
